import { motion } from "framer-motion";

export default function Skills() {

  const skills = [
    "HTML5",
    "CSS3",
    "JavaScript",
    "React",
    "Tailwind CSS",
    "Python",
    "Flask",
    "SQL",
    "Git",
    "GitHub",
    "Responsive Design",
    "Frontend Development"
  ];

  return (
    <motion.section
      id="skills"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
      className="mb-16"
    >

      <h2 className="text-3xl font-bold mb-6">
        Skills
      </h2>

      <div className="flex flex-wrap gap-3">

        {skills.map((skill) => (

          <div
            key={skill}
            className="bg-zinc-900 border border-zinc-800 hover:border-zinc-600 hover:-translate-y-1 transition duration-300 px-4 py-2 rounded-xl text-zinc-200"
          >
            {skill}
          </div>

        ))}

      </div>

    </motion.section>
  );
}